const AWS_CODEBUILD_ARN_ANNOTATION = "aws.amazon.com/aws-codebuild-project-arn";
const AWS_CODEBUILD_TAGS_ANNOTATION = "aws.amazon.com/aws-codebuild-project-tags";
const AWS_CODEBUILD_ARN_ANNOTATION_LEGACY = "aws.amazon.com/aws-codebuild-project";

export { AWS_CODEBUILD_ARN_ANNOTATION, AWS_CODEBUILD_ARN_ANNOTATION_LEGACY, AWS_CODEBUILD_TAGS_ANNOTATION };
//# sourceMappingURL=types.esm.js.map
